import { render, staticRenderFns } from "./TableNetIncomeDetails.vue?vue&type=template&id=7995cf90"
import script from "./TableNetIncomeDetails.vue?vue&type=script&lang=js"
export * from "./TableNetIncomeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports